module.exports = __webpack_public_path__ + "static/img/miaoshaquan.3b8f652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/miaoshaquan.jpg
// module id = /MyX
// module chunks = 128